import { getClientOverviewAsync } from '../../API/client/ClientAPI';
import { createAsyncSliceWithDataAndQuery } from '../createAsyncSliceWithDataAndQuery';

export const { slice: clientOverviewSlice, asyncAction: getClientOverviewAction } = createAsyncSliceWithDataAndQuery(
  'clientOverview',
  getClientOverviewAsync,
  { id: '', name: '', spruceEmail: '' }
);
